// Legacy code, just modularized

import $ from 'jquery';
import 'magnific-popup';

/* Contact form */
function showContactForm(params) {
  // Requires obj {contactId, contactName}

  if(!params && typeof(params) !== 'object') {
    return false;
  }

  var contactForm = $('#dynamic-contact-form').eq(0);

  if(contactForm.length !== 1) {
    return false;
  }

  if(!contactForm.prop('inited')) {
    contactForm.on('keyup keypress', function(evt) {
      var code = evt.keyCode || evt.which;
      if(code === 13) {
        evt.preventDefault();
        return false;
      }
    });
    contactForm.prop('inited',true);
  }

  // Prefill
  contactForm.find('input[name="contact_id"]').val(params.contactId);
  contactForm.find('#contact-name').text(params.contactName);
}

const contactForm = {
  init: function() {
    const $btns = $('.show-contact-form-button');

    if($btns.length) {
      // Click handlers
      $btns.on('click', function(e) {
        e.preventDefault();
        var params = {contactId: $(this).data('contact-id'), contactName: $(this).data('contact-name')};
        showContactForm(params);
      });

      $btns.magnificPopup({
        type: 'inline',
        midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
        closeBtnInside: false
      });
    }
  }
};

export default contactForm;
